var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"inner-pages",attrs:{"column":""}},[_c('Header'),_vm._v(" "),_c('scroll-data',{attrs:{"footer":false}},[(_vm.gameId === 62 || _vm.gameId === 69)?_c('Programs62'):_vm._e(),_vm._v(" "),(_vm.gameId === 68)?_c('Programs68'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71fbadba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Programs/Index.vue
// module id = 558
// module chunks = 4